import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { siteConfig } from '../config/siteConfig';
import { motion } from 'framer-motion';
export function VideoSection() {
  const [isPlaying, setIsPlaying] = useState(false);
  return <section className="w-full bg-brand-cream py-24 md:py-40" data-id="element-241">
      <div className="container mx-auto px-4 max-w-7xl flex flex-col items-center" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mb-12" data-id="element-243">
          <span className="text-brand-gold font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-244">
            {siteConfig.video.eyebrow}
          </span>
          <h2 className="font-heading text-3xl md:text-[40px] font-bold text-brand-navy mb-6 leading-tight" data-id="element-245">
            {siteConfig.video.headline}
          </h2>
          <p className="text-lg text-muted-foreground" data-id="element-246">
            {siteConfig.video.subtext}
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="w-full max-w-[960px] aspect-video relative rounded-2xl overflow-hidden shadow-2xl bg-gray-900 group cursor-pointer" onClick={() => setIsPlaying(true)} data-id="element-247">
          {!isPlaying ? <>
              <img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=1920" alt="Video Thumbnail" className="w-full h-full object-cover opacity-60 group-hover:opacity-50 transition-opacity duration-300" data-id="element-248" />
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-249">
                <div className="w-20 h-20 bg-brand-gold rounded-full flex items-center justify-center shadow-lg transform group-hover:scale-110 transition-transform duration-300" data-id="element-250">
                  <Play className="w-8 h-8 text-white ml-1" fill="currentColor" data-id="element-251" />
                </div>
              </div>
            </> : <iframe width="100%" height="100%" src={`https://www.youtube.com/embed/${siteConfig.video.youtubeId}?autoplay=1&rel=0&modestbranding=1`} title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-252"></iframe>}
        </motion.div>

        <p className="mt-6 text-sm text-muted-foreground text-center max-w-xl" data-id="element-253">
          {siteConfig.video.caption}
        </p>
      </div>
    </section>;
}